import React, { Fragment, useState } from "react";
import { Grid, Typography, Link } from "@mui/material";
import Project from "../../api/project";
import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/software-company-components/Footer/Footer";
import SEO from "../../components/SEO";
import FaqSection from "../../components/software-company-components/FaqSection/FaqSection";

function Faq() {
  return (
    <div>
      <Fragment>
        <SEO
            title=""
            description=""
            url="https://www.ufsnetworks.com/faq"
            image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
            canonicalUrl="https://www.ufsnetworks.com/faq"
        />
        <Header2 />
        <main>
            <PageTitle
            //pageTitle={"Revolutionizing Recruitment with AI-Powered Tools"}
            pagesub={"FAQ"}
            pageTop={""}
            />
        </main>
        <FaqSection />
        <Footer />
        <Scrollbar />
        </Fragment>
    </div>
  )
}

export default Faq
